import { atom } from 'recoil';

export const selectedFilesState = atom({
  key: 'selectedFiles',
  default: [],
});